var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlueberry = function SvgBlueberry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 270 270"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueberry_svg__a)",
    d: "M135.049 89c-67.479.385-80.139 85.935 2.932 91.824 68.352 4.845 71.343-92.246-2.932-91.824"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueberry_svg__b)",
    d: "M114.99 89.327c-50.288 15.337-52.5 86.085 23.045 91.493 61.676 4.414 71.085-73.485 19.793-90.968a12.8 12.8 0 0 0-4.867-.852A13.1 13.1 0 0 0 148 90a18.8 18.8 0 0 0 5 2c1.38.28 4.242 1.341 4.838 2.954s3.581 3.632 4.576 4.641c0 0-3.98 2.018-6.965 1.009s-2.986 1.009-6.966 1.009c0 0-2.985 4.036 1 6.054 0 0-4.975 5.045-6.965 3.027s-4.976-2.686-7.961-3.361-2.988-2.7-4.977-2.695-3.978 2.02-5.968 2.02-2.03 2.058-4 2.038-6.945-1.029-7.94-2.038c-.771-.782 4.478-7.568 4.478-9.586-1-1.009-1.445-1.563-1-2.018 1.989-2.018 7.85-5.014 7.85-5.014a34 34 0 0 0-6-1.04 6.6 6.6 0 0 0-2.01.327"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#blueberry_svg__c)",
    d: "M135 98c2.209 0 4-1.343 4-3s-1.791-3-4-3-4 1.343-4 3 1.791 3 4 3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueberry_svg__a",
    x1: 134.23,
    x2: 134.538,
    y1: 90.563,
    y2: 119.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7FBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8BC3DC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueberry_svg__b",
    x1: 135,
    x2: 135,
    y1: 181,
    y2: 88.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueberry_svg__c",
    x1: 135,
    x2: 135,
    y1: 98,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0DEEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3F8"
  })))));
};
export default SvgBlueberry;